import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var FcMaintenanceTypesOutlinedSelectService = /** @class */ (function () {
    function FcMaintenanceTypesOutlinedSelectService(apollo) {
        this.apollo = apollo;
    }
    FcMaintenanceTypesOutlinedSelectService.prototype.getMaintenanceTypesBySegmentId = function (segmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n          query segment($id: ID!) {\n            segment(id: $id) {\n              maintenanceTypes {\n                id\n                name\n              }\n            }\n          }\n        "], ["\n          query segment($id: ID!) {\n            segment(id: $id) {\n              maintenanceTypes {\n                id\n                name\n              }\n            }\n          }\n        "]))),
                        variables: {
                            id: segmentId
                        }
                    })
                        .toPromise()
                        .then(function (result) { return result.data['segment']['maintenanceTypes']; })];
            });
        });
    };
    FcMaintenanceTypesOutlinedSelectService.prototype.getPaginatedMaintenanceTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: gql(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n          query searchMaintenanceTypes($where: MaintenanceTypeWhereInput) {\n            maintenanceTypes(where: $where, orderBy: name_asc, limit: 100, offset: 0) {\n              items {\n                id\n                name\n              }\n            }\n          }\n        "], ["\n          query searchMaintenanceTypes($where: MaintenanceTypeWhereInput) {\n            maintenanceTypes(where: $where, orderBy: name_asc, limit: 100, offset: 0) {\n              items {\n                id\n                name\n              }\n            }\n          }\n        "]))),
                        variables: {
                            where: {
                                archived: false
                            }
                        }
                    })
                        .toPromise()
                        .then(function (result) { return result.data['maintenanceTypes']['items']; })];
            });
        });
    };
    FcMaintenanceTypesOutlinedSelectService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FcMaintenanceTypesOutlinedSelectService_Factory() { return new FcMaintenanceTypesOutlinedSelectService(i0.ɵɵinject(i1.Apollo)); }, token: FcMaintenanceTypesOutlinedSelectService, providedIn: "root" });
    return FcMaintenanceTypesOutlinedSelectService;
}());
export { FcMaintenanceTypesOutlinedSelectService };
var templateObject_1, templateObject_2;
